module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video9.256128a6.mp4";